// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2AglV","header":"ReportDetails_header__3xaVU","title":"ReportDetails_title__3a5SD","left":"ReportDetails_left__9DJix"};